import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications deve ser usado dentro de NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  const carregarNotificacoes = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(`${API_URL}/notificacoes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(data);
    } catch (err) {
      console.error('Erro ao carregar notificações:', err);
    }
  }, [API_URL]);

  const marcarComoLida = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_URL}/notificacoes/${id}/lida`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      carregarNotificacoes();
    } catch (err) {
      console.error('Erro ao marcar notificação como lida:', err);
    }
  };

  const marcarTodasComoLidas = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_URL}/notificacoes/marcar-todas-lidas`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      carregarNotificacoes();
    } catch (err) {
      console.error('Erro ao marcar todas como lidas:', err);
    }
  };

  const adicionarNotificacao = (notificacao) => {
    setNotifications(prev => [notificacao, ...prev]);
  };

  useEffect(() => {
    carregarNotificacoes();
    // Recarregar notificações a cada 30 segundos
    const interval = setInterval(carregarNotificacoes, 30000);
    return () => clearInterval(interval);
  }, [carregarNotificacoes]);

  const naoLidas = notifications.filter(n => !n.lida).length;

  return (
    <NotificationContext.Provider value={{
      notifications,
      naoLidas,
      marcarComoLida,
      marcarTodasComoLidas,
      adicionarNotificacao,
      carregarNotificacoes
    }}>
      {children}
    </NotificationContext.Provider>
  );
};
